// extracted by mini-css-extract-plugin
export default {"wrapper":"iS-z","availablePromoMessagesLabel":"jS-z","promoMessageList":"kS-z","promoMessage":"lS-z","appliedPromoMessage":"mS-z","promoMessageAmount":"nS-z"};